import { Loading } from 'element-ui';

// Loading
const LoadingComponent = (options) => {
  let config = {
    target: '.main-container',
    text: '加载中',
    background: 'rgba(255, 255, 255s, .2)'
  };
  config = Object.assign(config, options);
  return Loading.service(config);
};

export default (Vue) => {
  // 导入全局过滤器

  // 全局插件
  Vue.prototype.$partLoading = LoadingComponent;
  // Vue.prototype.$toast = Toast
  // Vue.prototype.$indicator = Indicator
};



// WEBPACK FOOTER //
// ./src/components/index.js